import React from "react"
import { ChakraProvider } from "@chakra-ui/react"
import { IntlProvider } from "react-intl"
import LanguageProvider from "./LanguageProvider"
import CookieConsent from "./CookieConsent"
import theme from "./theme"
import { messages } from "../intl/config"
import { getLocaleFromPath } from "../utils/routes"

export const wrapRootElement = ({ element }) => (
  <ChakraProvider theme={theme}>{element}</ChakraProvider>
)

export const wrapPageElement = ({ element, props }) => {
  const pathname = props.location.pathname
  const locale = getLocaleFromPath(pathname)
  return (
    <LanguageProvider pathname={pathname}>
      <IntlProvider locale={locale} messages={messages[locale]}>
        {element}
        <CookieConsent />
      </IntlProvider>
    </LanguageProvider>
  )
}
